const baseURL = "/v1/Funcao";

const service = {
  methods: {
    $buscarTipos() {
      return this.$api().get(`${baseURL}/Tipos`);
    },
    $buscarNomeDasFuncoes(){
      return this.$api().get(`${baseURL}/Nomes`);
    },
    $buscarFuncoes(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarFuncao(id) {
      return this.$api().get(`${baseURL}/${id}`);
    },
    $cadastrarFuncao(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarFuncao(id, body) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarFuncao(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    },
    $excluirFuncao(id) {
      return this.$api().delete(`${baseURL}/${id}`);
    },
    $detalharUsoFuncao({ id, params}) {
      return this.$api().get(`${baseURL}/DetalharUso/${id}`, params);
    },
  },
};

export default service;